import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import css from '../../common/Form.css'

const PatientPortalSubdirectory = ({ onChange, value }) => (
  <div className={css.formGroup}>
    <h3>Existing Patient Online Scheduling</h3>
    <Form.Item
      label="Patient Portal Subdirectory:"
      className={css.itemLabel}
      help={`This is for setting the URL subdirectory that patients will use to access the patient portal - e.g. patientportal.threadcommunication.com/${
        value || 'rooster-grin'
      }/`}
      key="PatientPortalSubdirectory"
    >
      <Input
        placeholder="rooster-grin"
        value={value}
        onChange={onChange}
        className={css.input}
        name="subdirectory"
      />
    </Form.Item>
  </div>
)

PatientPortalSubdirectory.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
}

PatientPortalSubdirectory.defaultProps = {
  value: '',
}

export default PatientPortalSubdirectory



// WEBPACK FOOTER //
// ./src/AddPractice/Products/PatientPortalSubdirectory.js